import React, { useEffect, useState } from "react";
import { Box, Grid2, Paper, Typography, useTheme } from "@mui/material";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useGetBulkUploadsQuery } from "store/slices/apis/bulkUploadSlice";
import moment from "moment";
import BulkUploadDetailsDialog from "components/BulkUpload/BulkUploadDetailsDialog";
import TableComponent from "components/grid";
import { usePermission } from "hooks/usePermission";
import { BULK_USER_TRANSACTION_VIEW } from "config";

const columns = [
  {
    name: "File Name",
    field: "fileName",
  },
  {
    name: "Uploaded At",
    field: "uploadedAt",
    renderer(params) {
      return (
        <>
          {params?.uploadedAt
            ? moment(params.uploadedAt).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Status",
    field: "status",
  },
  {
    name: "Action",
    field: "action",
    option: {},
  },
];

const Transactions = () => {
  const theme = useTheme();
  const [showDialog, setShowDialog] = useState(false);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const dispatch = useDispatch();
  const { data, isLoading, refetch } = useGetBulkUploadsQuery();
  const bulkViewAccess = usePermission(BULK_USER_TRANSACTION_VIEW);

  useEffect(() => {
    refetch();
  }, []);

  const handleActionView = (id) => {
    setSelectedFileId(id);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedFileId(null);
  };

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  return (
    <>
      <Grid2 container>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "24px"
            }}
          >
            <Typography
              sx={{
                fontSize: "24px",
                lineHeight: "35px",
                fontWeight: 500,
                marginLeft: "5px",
              }}
            >
              Bulk User Transaction
            </Typography>
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent
            columns={columns
              .map((col) =>
                col.field === "action"
                  ? {
                    ...col,
                    option: {
                      ...col.option,
                      view: bulkViewAccess,
                    },
                  }
                  : col
              )
              .filter((col) => {
                if (col.field !== "action") {
                  return true;
                } else {                  
                  return Object.values(col.option).some((v) => v === true);
                }

              })}
            data={data}
            actionView={handleActionView}
          />
        </Grid2>
      </Grid2>
      <BulkUploadDetailsDialog
        selectedFile={selectedFileId}
        open={showDialog}
        onClose={handleCloseDialog}
      />
    </>
  );
};

export default Transactions;
